import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Error } from '../components/templates/error/Error';

const NotFoundPage = () => {
  const { notFoundData } = useStaticQuery(graphql`
    query notFoundQuery {
      notFoundData: umbracoErrorPageType {
        heading
        subHeading
        description
        links {
          name
          url
        }
      }
    }
  `);

  return <Error {...notFoundData} />;
};

export default NotFoundPage;
